import { referenceUnitConstants } from './constants'

const initialState =
	{
		list  : [],
		isSending	    : false,
		error		    : null
	}

export default function (state = initialState, action){
	switch (action.type){
		case referenceUnitConstants.GetReferenceUnits.REQUEST:
			return {
				...state,
				isSending : true
			}
		case referenceUnitConstants.GetReferenceUnits.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case referenceUnitConstants.GetReferenceUnits.SUCCESS:
			return {
				...state,
				isSending : false,
				list : action.payload.result
			}
		case referenceUnitConstants.ClearReferenceUnits:
			return {
				...state,
				list : []
			}
		default:
			return state
	}
}